<ng-container *ngIf="user && user.firstName && user.lastName">
  <div class="ds-grid d-flex p-sm-0">
    <div class="me-3">
      <span class="ds-profile-placeholder icon-xl"></span>
    </div>
    <div class="d-flex flex-column justify-content-center">
      <h3 class="ds-heading--xs mb-0">{{user.firstName}} {{user.lastName}}</h3>
      <p *ngIf="userAddress" class="ds-fine-print mb-0 text-break">
        {{userAddress}}
      </p>
    </div>
  </div>
</ng-container>
